import styled from "styled-components";
import {
  QUERIES,
  SPACING,
  SPACING_RESPONSIVE,
} from "../../../../../utils/constants";
import { LineStyle } from "./types";

export const ProgressCard = styled.section`
  background: var(--color-card-background);
  border: 1px solid var(--color-card-border);
  border-radius: 12px;
  box-shadow: var(--shadow-small);
  font-family: "Crimson Pro", sans-serif;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  padding: ${SPACING_RESPONSIVE.mobile.chartPadding}px;
  margin: ${SPACING_RESPONSIVE.mobile.sectionGap}px;
  margin-bottom: 0px;

  @media ${QUERIES.tabletAndUp} {
    padding: ${SPACING_RESPONSIVE.tablet.chartPadding}px;
    margin: ${SPACING_RESPONSIVE.tablet.sectionGap}px;
    margin-bottom: 0px;
  }

  @media ${QUERIES.laptopAndUp} {
    padding: ${SPACING_RESPONSIVE.desktop.chartPadding}px;
    margin: ${SPACING_RESPONSIVE.desktop.sectionGap}px;
    margin-bottom: 0px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;

  @media ${QUERIES.tabletAndUp} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xxl);
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--color-text-default);
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: var(--text-base);
  font-style: italic;
  color: var(--color-text-secondary);
`;

export const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.lg}px;
`;

export const LegendItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  font-size: var(--text-base);
  color: var(--color-text-secondary);
`;

export const LegendSwatch = styled.span<{ $color: string; $style: LineStyle }>`
  width: 22px;
  height: 0;
  border-top-width: 3px;
  border-top-color: ${({ $color }) => $color};
  border-top-style: ${({ $style }) => $style};
  border-radius: 3px;
`;

export const EmptyMessage = styled.p`
  margin: 0;
  padding: ${SPACING.xxl}px ${SPACING.md}px;
  text-align: center;
  color: var(--color-text-secondary);
  font-size: var(--text-md);
`;

export const DesktopControl = styled.div`
  display: none;

  @media ${QUERIES.tabletAndUp} {
    display: block;
  }
`;

export const MobileControl = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${SPACING.sm}px;

  @media ${QUERIES.tabletAndUp} {
    display: none;
  }
`;
